<template>
	<div>
		<div class="modal fade" id="CatModal" data-backdrop="static">
			<div class="modal-dialog" role="document">
				<!--
				=================================================================================================================
													  MAIN/EXAM CREATION MODAL!
				=================================================================================================================
			-->

				<div
					class="modal-content"
					v-if="
						!this.data.creationCPF &&
						!this.data.creationShip &&
						!this.data.creationPassaport &&
						!this.data.creationType
					"
				>
					<div class="modal-header">
						<button
							type="button"
							class="close"
							data-dismiss="modal"
							aria-label="Close"
						>
							<span aria-hidden="true">&times;</span>
						</button>
						<h4 class="modal-title" id="myModalLabel">
							PRONTUARIO DE EXAMES DOF
						</h4>
					</div>
					<div class="modal-body">
						<div class="col-sm-3">
							<span>CPF</span>
							<div class="add-more-section">
								<input
									type="text"
									v-model="data.CPF"
									class="form-control"
									v-on:change="handleChangeCPF()"
									ref="cpf"
									id="cpf"
									v-mask="'###.###.###-##'"
									placeholder="999.999.999-99"
								/>
								<aBtn
									@click="handleToggleCreationCPF()"
									text=""
									icon="plus"
									size="sm"
									type="success"
								/>
							</div>
						</div>

						<div class="col-sm-4">
							<span>NOME</span>
							<input
								readonly
								type="text"
								v-model="data.nome"
								class="form-control"
								placeholder="NOME"
							/>
						</div>

						<div class="col-sm-3">
							<span>Data de Nascimento</span>
							<input
								readonly
								type="text"
								v-model="data.dataNasc"
								class="form-control"
								v-mask="'##/##/####'"
								placeholder="01/01/1970"
							/>
						</div>

						<div class="col-sm-2">
							<span>PASSAPORT</span>
							<div class="add-more-section">
								<input
									type="text"
									v-model="data.passaport"
									class="form-control"
									v-on:change="handleChangePassaport()"
									placeholder="PASSAPORT"
								/>
								<aBtn
									@click="handleToggleCreationPassaport()"
									text=""
									icon="plus"
									size="sm"
									type="success"
								/>
							</div>
						</div>

						<div class="col-sm-3">
							<span>NAVIO</span>
							<div class="add-more-section">
								<select
									v-model="data.navio"
									class="form-control"
								>
									<option
										v-for="(navio, index) in this.navios"
										:key="index"
										:value="navio.navio"
									>
										{{ navio.navio }}
									</option>
								</select>
							</div>
						</div>

						<div class="col-sm-5">
							<span>LOCAL DE COLETA</span>
							<select
								v-model="data.localTeste"
								class="form-control"
								@change="onSelectLocalDeColeta($event)"
							>
								<option
									v-for="(local, index) in localDoteste"
									:name="index"
									:value="local.nome_local_exame"
									:key="index"
								>
									{{ local.nome_local_exame }}
								</option>
							</select>
						</div>

						<div class="col-sm-4">
							<span>Laboratório</span>
							<select
								v-model="data.laboratorio"
								class="form-control"
							>
								<option
									v-for="(lab, index) in laboratory"
									:key="index"
									:value="lab"
								>
									{{ lab }}
								</option>
							</select>
						</div>

						<div class="col-sm-3">
							<span>Cidade</span>
							<input
								type="text"
								v-model="data.municipio"
								class="form-control"
								ref="municipio"
								id="municipio"
								placeholder="CIDADE"
							/>
						</div>

						<div class="col-sm-2">
							<span>Estado</span>
							<select
								v-model="data.estado"
								class="form-control"
								@change="onSelectState()"
							>
								<option
									v-for="(estado, index) in estados"
									:key="index"
									:value="estado.sigla"
								>
									{{ estado.nome.toUpperCase() }}
								</option>
							</select>
						</div>

						<div class="col-sm-3">
							<span>TIPO DE EXAME</span>

							<div class="add-more-section">
								<select
									v-model="data.tipoTeste"
									class="form-control"
								>
									<option
										v-for="(teste, index) in tipoTeste"
										:key="index"
										:value="teste.nome_tipo_exame"
									>
										{{ teste.nome_tipo_exame }}
									</option>
								</select>
							</div>
						</div>

						<div class="col-sm-4">
							<span>Parceiro</span>
							<select
								v-model="data.parceiro"
								class="form-control"
							>
								<option
									v-for="(pa, index) in parca"
									:key="index"
									:value="pa"
								>
									{{ pa }}
								</option>
							</select>
						</div>

						<div class="col-sm-3">
							<span>DATA COLETA</span>

							<input
								class="form-control"
								type="date"
								v-model="data.dataTesteFormatada"
								v-on:change="
									handleChangeDataFormat($event, 'dataTeste')
								"
								id="dataTesteFormatada"
							/>
						</div>

						<div class="col-sm-3">
							<span>DATA LAUDO</span>

							<input
								class="form-control"
								type="date"
								v-model="data.dataResultadoFormatada"
								v-on:change="
									handleChangeDataFormat(
										$event,
										'dataResultado'
									)
								"
								id="dataTesteFormatada"
							/>
						</div>

						<div class="col-sm-4">
							<span>RESULTADO</span>
							<select
								v-model="data.resultado"
								class="form-control"
							>
								<option
									v-for="(resultado, index) in resultados"
									:key="index"
									:value="resultado.resultado_exame"
								>
									{{ resultado.resultado_exame }}
								</option>
							</select>
						</div>

						<div class="col-sm-2">
							<span>TEMPO</span>

							<p readonly class="form-control">
								{{ data.tempoResultado }} hora{{
									data.tempoResultado != 0 &&
									data.tempoResultado == 1
										? ''
										: 's'
								}}
							</p>
						</div>

						<div class="clearfix"></div>
						<br />
					</div>
					<div class="modal-footer">
						<div class="modal-footer__buttons">
							<button
								type="button"
								class="btn btn-default"
								data-dismiss="modal"
							>
								<i class="fa fa-close"></i> Cancelar
							</button>

							<div class="flex-container">
								<div class="flex-container__item">
									<div
										class="flex-container__item__upload-container__flex-item"
									>
										<label
											class="form-control--no-padding"
											for="inputTag"
										>
											<div class="btn-upload-image">
												Anexar imagem
												<i class="fa fa-upload"></i>
											</div>
											<div class="file">
												<input
													type="file"
													class="inputTag"
													accept=".jpg, .png, .jpeg, .gif, .bmp, .tif, .svg, .pdf, .tiff|image/*"
													v-on:change="
														handleUploadImage(
															$event
														)
													"
													id="inputTag"
												/>
											</div>
										</label>
									</div>
								</div>
								<div class="flex-container__item">
									<aBtn
										action="private-save-exams"
										@click="save"
										text="Salvar"
										icon="save"
										type="primary"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!--
				=================================================================================================================
													CREATE COLABORATOR MODAL!
				=================================================================================================================
			-->

				<div class="modal-content" v-if="this.data.creationCPF">
					<div class="modal-header">
						<button
							type="button"
							class="close"
							data-dismiss="modal"
							aria-label="Close"
						>
							<span aria-hidden="true">&times;</span>
						</button>
						<h4 class="modal-title" id="myModalLabel">
							PRONTUARIO DE EXAMES DOF
						</h4>
					</div>
					<div class="modal-body">
						<div class="col-sm-4">
							<span>CPF</span>
							<input
								class="form-control"
								type="text"
								v-model="data.CPF"
								v-on:change="handleChangeCPF()"
								ref="cpf"
								id="cpf"
								v-mask="'###.###.###-##'"
							/>
						</div>

						<div class="col-sm-8">
							<span>NOME</span>
							<input
								class="form-control"
								type="text"
								v-model="data.nome"
								ref="nome"
								id="nome"
							/>
						</div>

						<div class="col-sm-6">
							<span>RG/PASSAPORTE</span>
							<input
								class="form-control"
								type="number"
								v-model="data.RG"
								ref="rg"
								id="rg"
							/>
						</div>

						<div class="col-sm-3">
							<span>Cargo</span>
							<select v-model="data.cargos" class="form-control">
								<option
									v-for="(cargo, index) in cargos"
									:key="index"
									:value="cargo.nome_cargo"
								>
									{{ cargo.nome_cargo }}
								</option>
							</select>
						</div>

						<div class="col-sm-3">
							<span>NAVIO</span>
							<div class="add-more-section">
								<select
									v-model="data.navio"
									class="form-control"
								>
									<option
										v-for="(navio, index) in this.navios"
										:key="index"
										:value="navio.navio"
									>
										{{ navio.navio }}
									</option>
								</select>
							</div>
						</div>

						<div class="col-sm-5">
							<span>Empresa</span>
							<select v-model="data.empresa" class="form-control">
								<option
									v-for="(empresa, index) in empresas"
									:key="index"
									:value="empresa.razao_social"
								>
									{{ empresa.razao_social }}
								</option>
							</select>
						</div>

						<div class="col-sm-4">
							<span>Data de Nascimento</span>
							<input
								type="text"
								v-model="data.dataNasc"
								class="form-control"
								v-mask="'##/##/####'"
							/>
						</div>

						<div class="clearfix"></div>
						<br />
					</div>
					<div class="modal-footer">
						<div class="modal-footer__buttons">
							<button
								type="button"
								class="btn btn-default"
								@click="handleToggleCreationCPF()"
							>
								<i class="fa fa-close"></i> Cancelar
							</button>

							<aBtn
								action="private-save-exams"
								@click="saveCpf"
								text="Salvar"
								icon="save"
								type="primary"
							/>
						</div>
					</div>
				</div>

				<!--
				=================================================================================================================
														CREATE SHIP MODAL!
				=================================================================================================================
			-->

				<div class="modal-content" v-if="this.data.creationShip">
					<div class="modal-header">
						<button
							type="button"
							class="close"
							data-dismiss="modal"
							aria-label="Close"
						>
							<span aria-hidden="true">&times;</span>
						</button>
						<h4 class="modal-title" id="myModalLabel">
							PRONTUARIO DE EXAMES DOF
						</h4>
					</div>
					<div class="modal-body">
						<div class="col-sm-12">
							<span>EMPRESA</span>
							<input
								type="text"
								v-model="data.empresa"
								class="form-control"
							/>
						</div>

						<div class="col-sm-2">
							<span>FROTA</span>
							<input
								type="text"
								v-model="data.frota"
								class="form-control"
							/>
						</div>

						<div class="col-sm-10">
							<span>NAVIO</span>
							<input
								type="text"
								v-model="data.navio"
								class="form-control"
							/>
						</div>

						<div class="clearfix"></div>
						<br />
					</div>
					<div class="modal-footer">
						<div class="modal-footer__buttons">
							<button
								type="button"
								class="btn btn-default"
								@click="handleToggleCreationShip()"
							>
								<i class="fa fa-close"></i> Cancelar
							</button>

							<aBtn
								action="private-save-exams"
								@click="saveShip"
								text="Salvar"
								icon="save"
								type="primary"
							/>
						</div>
					</div>
				</div>

				<!--
				=================================================================================================================
													CREATE TYPE OF EXAM MODAL!
				=================================================================================================================
			-->

				<div class="modal-content" v-if="this.data.creationType">
					<div class="modal-header">
						<button
							type="button"
							class="close"
							data-dismiss="modal"
							aria-label="Close"
						>
							<span aria-hidden="true">&times;</span>
						</button>
						<h4 class="modal-title" id="myModalLabel">
							PRONTUARIO DE EXAMES DOF
						</h4>
					</div>
					<div class="modal-body">
						<div class="col-sm-12">
							<span>Nome</span>
							<input
								type="text"
								v-model="data.nome_tipo_exame"
								class="form-control"
							/>
						</div>

						<div class="clearfix"></div>
						<br />
					</div>
					<div class="modal-footer">
						<div class="modal-footer__buttons">
							<button
								type="button"
								class="btn btn-default"
								@click="handleToggleCreationType()"
							>
								<i class="fa fa-close"></i> Cancelar
							</button>

							<aBtn
								action="private-save-exams"
								@click="saveType"
								text="Salvar"
								icon="save"
								type="primary"
							/>
						</div>
					</div>
				</div>

				<!--
				=================================================================================================================
													CREATE PASSAPORT MODAL!
				=================================================================================================================
			-->

				<div class="modal-content" v-if="this.data.creationPassaport">
					<div class="modal-header">
						<button
							type="button"
							class="close"
							data-dismiss="modal"
							aria-label="Close"
						>
							<span aria-hidden="true">&times;</span>
						</button>
						<h4 class="modal-title" id="myModalLabel">
							PRONTUARIO DE EXAMES DOF
						</h4>
					</div>
					<div class="modal-body">
						<div class="col-sm-12">
							<span>Nome</span>
							<input
								type="text"
								v-model="data.nome"
								class="form-control"
							/>
						</div>

						<div class="col-sm-12">
							<span>PASSAPORT</span>
							<input
								type="text"
								v-model="data.passaport"
								class="form-control"
							/>
						</div>

						<div class="clearfix"></div>
						<br />
					</div>
					<div class="modal-footer">
						<div class="modal-footer__buttons">
							<button
								type="button"
								class="btn btn-default"
								@click="handleToggleCreationPassaport()"
							>
								<i class="fa fa-close"></i> Cancelar
							</button>

							<aBtn
								action="private-save-exams"
								@click="savePassaport"
								text="Salvar"
								icon="save"
								type="primary"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	/*

	id precisa existir para poder ocorrer a criação

	*/
	import clone from 'js/clone';
	import aBox from 'box';
	import aBtn from 'btn';
	import WBS from 'js/http';
	import toastr from 'toastr';
	import axios from 'axios';
	import moment from 'moment';
	import { mask } from 'vue-the-mask';
	// md-autocomplete MdAutocomplete
	import { MdAutocomplete } from 'vue-material/dist/components';

	let reset = {
		empresa: '',
		nome: '',
		colaborador: '',
		cargo: '',
		navio: '',
		frota: '',
		idade: 0,
		tipoTeste: '',

		dataNasc: '',

		anexo: '',

		localTeste: '',

		dataTeste: `${new Date().getFullYear()}-${
			new Date().getMonth() + 1 < 10 && 0
		}${new Date().getMonth() + 1}-${new Date().getDate()}T${
			new Date().getHours() < 10 ? 0 : ''
		}${new Date().getHours()}:${
			new Date().getMinutes() <= 10 ? 0 : ''
		}${new Date().getMinutes()}`,
		dataTesteFormatada: ``,

		dataResultadoFormatada: ``,
		dataResultado: `${new Date().getFullYear()}-${
			new Date().getMonth() + 1 < 10 && 0
		}${new Date().getMonth() + 1}-${new Date().getDate()}T${
			new Date().getHours() < 10 ? 0 : ''
		}${new Date().getHours()}:${
			new Date().getMinutes() <= 10 ? 0 : ''
		}${new Date().getMinutes()}`,

		laboratorio: '',
		parceiro: '',
		tempoResultado: 0,
		tempoResultadoFormatado: '0 horas',
		resultado: false,
		creationCPF: false,
		creationShip: false,
		creationType: false,
		creationPassaport: false,
		municipio: '',
		estado: '',
		RG: '',
		CPF: '',
		passaport: '',
		nome_tipo_exame: '',
		localTesteIndex: '',
		control: '',
	};

	export default {
		name: 'ChModalExames',
		components: { aBox, aBtn, mask },
		data() {
			return {
				data: {
					moment: moment,
					...clone(reset),
				},
				test: null,
				pessoas: [],

				cargos: [
					{
						navio: 'Não há dados',
					},
				],

				navios: [
					{
						navio: 'Não há dados',
					},
				],

				estados: null,
				municipios: null,
				tipoTeste: [
					{
						nome_tipo_exame: 'Não há dados!',
					},
				],
				localDoteste: [
					{
						nome_local_exame: 'Não há dados!',
					},
				],

				empresas: [
					{
						razao_social: 'Não há dados!',
					},
				],

				resultados: [
					{
						resultado_exame: 'Positivo',
						id: '0',
					},
					{
						resultado_exame: 'Negativo',
						id: '1',
					},
					{
						resultado_exame: 'Inconclusivo',
						id: '2',
					},
				],

				laboratory: [
					'ABBOTT',
					'CONTRAPROVA',
					'HECIN',
					'HEMOCLIN',
					'HI LAB',
					'LABORLIFE',
					'TOMMASI',
					'ALIANCA',
				],

				parca: ['HEMOCLIN', 'SOLANA', 'VIAMED', 'TOMMASI'],
			};
		},

		computed: {
			classObject: function () {
				return {
					'link--active': !!this.data.anexo,
					'link--inactive': !this.data.anexo,
				};
			},
		},
		methods: {
			format(value, event) {
				return moment(value).format('YYYY-MM-DD');
			},

			handleConvertStringToDateTime(stringValue) {
				return moment(stringValue, 'DD/MM/YYYY HH:mm').format(
					'YYYY-MM-DD HH:mm:00'
				);
			},

			handleParseDateTimeToString(dateTimeValue) {
				return moment(dateTimeValue, 'YYYY-MM-DD HH:mm:00').format(
					'DD/MM/YYYY HH:mm'
				);
			},

			handleChangeDataFormat(e, dateModel) {
				const stringValue = e.target.value;
				const dateStringParsed =
					moment(stringValue).format('YYYY-MM-DD');
				this.data[dateModel] = dateStringParsed;

				this.handleUpdateResultDate();
			},

			handleUploadImage(e) {
				const file = e.target.files[0];

				const fileName = file.name.replace(/ /g, '');

				var blob = file.slice(0, file.size, file.type);
				const updatedFile = new File([blob], fileName, {
					type: file.type,
				});

				this.uploadImage(updatedFile);
			},

			async uploadImage(file) {
				const backendUrl = 'http://viamed.ddns.net:3000';

				const formData = new FormData();
				formData.append('file', file);

				const uploadedImageUrl = await axios
					.post(`${backendUrl}/upload`, formData, {
						headers: {
							Accept: 'application/json',
							'Content-Type': 'multipart/form-data',
							'Access-Control-Allow-Origin': '*',
						},
					})
					.then(() => `${backendUrl}/uploads/${file.name}`);
				this.data.anexo = uploadedImageUrl;
			},

			onSelectCargo(val) {
				this.cargo = val.nome_cargo;
			},

			onSelectLocal(val) {
				this.localTeste = val.nome_local_exame;

				let index = val.id;

				let selectedLocal = this.localDoteste[index];

				/*
				id: 1
				estado: "AP"
				municipio: "Amapá"
				nome_local_exame: "NOME"
				*/

				this.data.estado = selectedLocal.estado.toUpperCase();
				this.data.municipio = selectedLocal.municipio;
				this.data.nome_local_exame = selectedLocal.nome_local_exame;
			},

			onSelectTipoExame(val) {
				this.data.tipoTeste = val.nome_tipo_exame;
			},

			handleUpdateResultDate() {
				const dataTesteFormatada = new Date(this.data.dataTeste);
				const dataResuladoFormatada = new Date(this.data.dataResultado);

				const dataTesteNumerico = Date.parse(dataTesteFormatada);
				const dataResuladoNumerico = Date.parse(dataResuladoFormatada);

				const razao = dataResuladoNumerico - dataTesteNumerico;

				const dias = razao / (1000 * 60 * 60 * 24);

				const minutosTotais = razao / 60000;

				let horas =
					isNaN(minutosTotais / 60) || minutosTotais / 60 < 0
						? 0
						: minutosTotais / 60;

				const tempoResultado = `${horas.toFixed()} hora${
					horas.toFixed() == 1 ? '' : 's'
				} `;

				this.data.tempoResultadoFormatado = tempoResultado;
				this.data.tempoResultado = horas.toFixed();
			},

			handleChangeCPF() {
				const cpf = String(this.data.CPF).replace(/[^\w\s]/gi, '');

				if (cpf.length < 9) return;

				const testParms = {
					pager: {
						page: '0',
						qnt: '999',
					},
					filter: `cpf=${cpf}`,
				};

				WBS.send('private-read-pessoas', testParms, (resp) => {
					if (!resp.data.table[0]) {
						return toastr.error('CPF não cadastrado');
					}

					const tableValues = resp.data.table[0];

					this.data.empresa = tableValues.empresa;
					this.data.nome = tableValues.nome; //colaborador
					this.data.dataNasc = tableValues.dataNasc;
					this.data.RG = tableValues.RG;
					this.data.cargo = tableValues.cargo;
				});
			},

			handleChangePassaport() {
				const passaport = String(this.data.passaport).replace(
					/[^\w\s]/gi,
					''
				);
				if (passaport.length < 2) return;

				const testParms = {
					pager: {
						page: '0',
						qnt: '999',
					},
					filter: `passaport=${passaport}`,
				};

				WBS.send('private-read-passaport', testParms, (resp) => {
					if (!resp.data.table[0]) {
						return toastr.error('Passaporte não cadastrado');
					}

					const tableValues = resp.data.table[0];

					this.data.empresa = tableValues.empresa;
					this.data.nome = tableValues.nome; //colaborador
					this.data.RG = tableValues.RG;
					this.data.dataNasc = tableValues.dataNasc;
					this.data.cargo = tableValues.cargo;
				});
			},

			handleToggleCreationCPF() {
				this.data.creationCPF = !this.data.creationCPF;
			},

			handleToggleCreationShip() {
				this.data.creationShip = !this.data.creationShip;
			},

			handleToggleCreationType() {
				this.data.creationType = !this.data.creationType;
			},

			handleToggleCreationPassaport() {
				this.data.creationPassaport = !this.data.creationPassaport;
			},

			open(data = null) {
				if (data != null) {
					data.dataTesteFormatada = moment(data.dataTeste).format(
						'YYYY-MM-DD'
					);
					data.dataResultadoFormatada = moment(
						data.dataResultado
					).format('YYYY-MM-DD');

					this.data = clone(data);
				} else this.data = clone(reset);
				$('#CatModal').modal('show');
			},
			save() {
				this.data.CPF = String(this.data.CPF).replace(/[^\w\s]/gi, '');

				this.data.control = `${this.data.CPF} ${this.data.dataTeste}`;

				WBS.send('private-save-exams', this.data, (resp) => {
					if (resp.status == 'success') {
						toastr.success('Registro alterado com sucesso!');
						this.$emit('update');
						$('#CatModal').modal('hide');
					} else {
						toastr.error(resp.msgs[0]);
					}
				});
			},

			saveCpf() {
				this.data.CPF = String(this.data.CPF).replace(/[^\w\s]/gi, '');

				WBS.send('private-save-pessoas', this.data, (resp) => {
					if (resp.status == 'success') {
						toastr.success('Registro alterado com sucesso!');
						this.handleToggleCreationCPF();
					} else {
						toastr.error(resp.msgs[0]);
					}
				});
			},

			saveShip() {
				WBS.send('private-save-navios', this.data, (resp) => {
					if (resp.status == 'success') {
						toastr.success('Registro alterado com sucesso!');
						this.handleToggleCreationShip();

						this.handleLoadNavios();
					} else {
						toastr.error(resp.msgs[0]);
						console.error(resp);
						console.error(this.data);
					}
				});
			},

			handleLoadNavios() {
				const testParms = {
					pager: {
						page: '0',
						qnt: '9999',
					},
				};

				WBS.send('private-read-navios', testParms, (resp) => {
					const unorderednavios = resp.data.table;
					this.navios = unorderednavios.sort((a, b) =>
						a.navio.localeCompare(b.navio)
					); //order the object alphabetically

					if (this.navios.length - 1 > 0) {
						const lastNavio = this.navios[this.navios.length - 1];
						this.data.navio = lastNavio.navio;
					}
				});
			},

			handleLoadCargos() {
				const testParms = {
					pager: {
						page: '0',
						qnt: '9999',
					},
				};

				WBS.send('private-read-cargos', testParms, (resp) => {
					const unorderedCargos = resp.data.table;
					this.cargos = unorderedCargos.sort((a, b) =>
						a.nome_cargo.localeCompare(b.nome_cargo)
					); //order the object alphabetically
				});
			},

			handleLoadTiposDeExames() {
				const testParms = {
					pager: {
						page: '0',
						qnt: '9999',
					},
				};

				WBS.send('private-read-tipos_de_exame', testParms, (resp) => {
					const unorderedTipoTeste = resp.data.table;
					this.tipoTeste = unorderedTipoTeste.sort((a, b) =>
						a.nome_tipo_exame.localeCompare(b.nome_tipo_exame)
					); //order the object alphabetically

					const lastTipoDeExame =
						this.tipoTeste[this.tipoTeste.length - 1];

					this.data.tipoTeste = lastTipoDeExame.nome_tipo_exame;
				});
			},

			handleLoadLocalDeExames() {
				const testParms = {
					pager: {
						page: '0',
						qnt: '9999',
					},
				};

				WBS.send('private-read-local_de_exame', testParms, (resp) => {
					const unorderedLocalDoteste = resp.data.table;
					this.localDoteste = unorderedLocalDoteste.sort((a, b) =>
						a.nome_local_exame.localeCompare(b.nome_local_exame)
					); //order the object alphabetically
				});
			},

			handleExamesResults() {
				const testParms = {
					pager: {
						page: '0',
						qnt: '9999',
					},
				};

				WBS.send(
					'private-read-resultados_exames',
					testParms,
					(resp) => {
						this.resultados = resp.data.table;
					}
				);
			},

			handleLoadEmpresas() {
				const testParms = {
					pager: {
						page: '0',
						qnt: '9999',
					},
					filter: `regiao='OFF'`,
				};

				WBS.send('private-read-customers', testParms, (resp) => {
					const unorderedEmpresas = resp.data.table;
					this.empresas = unorderedEmpresas.sort((a, b) =>
						a.razao_social.localeCompare(b.razao_social)
					); //order the object alphabetically
				});
			},

			savePassaport() {
				WBS.send('private-save-passaport', this.data, (resp) => {
					if (resp.status == 'success') {
						toastr.success('Registro alterado com sucesso!');
						this.handleToggleCreationPassaport();
					} else {
						toastr.error(resp.msgs[0]);
						console.error(resp);
						console.error(this.data);
					}
				});
			},

			saveType() {
				WBS.send('private-save-tipos_de_exame', this.data, (resp) => {
					if (resp.status == 'success') {
						toastr.success('Registro alterado com sucesso!');
						this.handleToggleCreationType();
						this.handleLoadTiposDeExames();
					} else {
						toastr.error(resp.msgs[0]);
						console.error(resp);
						console.error(this.data);
					}
				});
			},

			onSelectLocalDeColeta(e) {
				let index = e.target.selectedIndex;

				let selectedLocal = this.localDoteste[index];

				this.data.localTeste = selectedLocal.nome_local_exame;
				this.data.estado = selectedLocal.estado.toUpperCase();
				this.data.municipio = selectedLocal.municipio;
				this.data.nome_local_exame = selectedLocal.nome_local_exame;
			},

			onSelectState() {
				axios
					.get(
						`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${this.data.estado}/municipios?orderBy=nome`
					)
					.then((response) => (this.municipios = response.data));
			},
		},

		mounted() {
			axios
				.get(
					'https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome'
				)
				.then((response) => (this.estados = response.data));

			this.handleLoadNavios();
			this.handleLoadTiposDeExames();
			this.handleExamesResults();
			this.handleLoadEmpresas();
			this.handleLoadCargos();
			this.handleLoadLocalDeExames();
		},
	};
</script>

<style>
	span {
		text-transform: uppercase;
	}

	.modal-dialog {
		width: 80% !important;
	}

	.modal-footer__buttons {
		display: flex;
		justify-content: space-between;
	}

	.add-more-section {
		display: flex;
	}
	/*
.table{
	overflow
}
*/

	.md-autocomplete + strong {
		margin-top: 36px;
		display: block;
	}

	.md-autocomplete-items {
		z-index: 99 !important;
		background: white !important;
		position: relative !important;
		top: 85% !important;
	}

	.md-menu-content {
		min-width: 33% !important;
		background: white !important;
		/*
	top: 430px !important;
	*/
		z-index: 99999 !important;
	}

	.md-list {
		width: 100% !important;
		background: white;
		top: 430px !important;
		z-index: 99999;
	}

	.col--featured {
		/*
	*/
		height: 54px !important;
	}

	.file {
		display: none;
	}

	.image-upload {
		width: 30vw;
		height: 30vw;
		border-radius: 1px;
		border: 1px solid #d2d6de;
		object-fit: cover;
	}

	label {
		font-weight: normal;
		text-transform: uppercase;
	}

	.link {
		text-transform: none;
	}

	.link:hover {
		filter: contrast(200%);
	}

	.link--active {
		text-transform: none;
		color: #333;
	}

	.link--inactive {
		color: #ccc !important;
	}

	.btn-upload-image {
		text-transform: none;

		background-color: #d35c32 !important;

		color: white;

		border-radius: 3px;
		-webkit-box-shadow: none;
		box-shadow: none;
		border: 1px solid transparent;

		padding: 6px 12px;

		font-size: 14px;

		-webkit-box-shadow: none;
		box-shadow: none;

		display: inline-block;
		padding: 6px 12px;
		font-size: 14px;
		font-weight: 400;
		line-height: 1.42857143;
		text-align: center;
		white-space: nowrap;
		vertical-align: middle;
		-ms-touch-action: manipulation;
		touch-action: manipulation;
		cursor: pointer;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
		background-image: none;
		/* border: 1px solid #ccc; */
		border-radius: 4px;
	}

	.fa,
	.fa-spin,
	.fa-spinner {
		overflow: visible !important;
	}

	.upload-container {
		display: flex;
		flex-direction: column;
	}

	.flex-container {
		display: flex;
		gap: 10px;
		margin: 0 !important;
	}

	.flex-container__item__upload-container__flex-item {
		display: flex;
		gap: 10px;
		align-items: center;
		/* width: 100%; */
		width: 30%;
	}

	.form-control--no-padding {
		padding: 0;
		margin: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/cadastros/exames/modal.vue